function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var delegator = new (/*#__PURE__*/function () {
  function Delegator() {
    _classCallCheck(this, Delegator);
    this.events = {};
    this.listener = this._onEventTriggered.bind(this);
    document.addEventDelegate = this.on.bind(this);
    document.removeEventDelegate = this.off.bind(this);
    document.dispatchEventDelegate = this.dispatch.bind(this);
  }
  return _createClass(Delegator, [{
    key: "on",
    value: function on(name, callback, selector) {
      selector = selector ? selector : document;
      if (!this.events[name]) {
        this.events[name] = [];
        document.addEventListener(name, this.listener);
      }
      this.events[name].push({
        selector: selector,
        callback: callback
      });
    }
  }, {
    key: "off",
    value: function off(name, callback, selector) {
      selector = selector ? selector : document;
      var triggers = this.events[name];
      if (triggers) {
        for (var i in triggers) {
          var trigger = triggers[i];
          if (trigger.selector === selector && trigger.callback.name == callback.name) {
            delete triggers[i];
          }
        }
        this.events[name] = triggers.filter(function (o) {
          return !!o;
        });
        if (!this.events[name].length) {
          document.removeEventListener(name, this.listener);
        }
      }
    }
  }, {
    key: "dispatch",
    value: function dispatch(name, data, opts) {
      opts = opts || {};
      opts.detail = data;
      document.dispatchEvent(new CustomEvent(name, opts));
    }
  }, {
    key: "_onEventTriggered",
    value: function _onEventTriggered(e) {
      var triggers = this.events[e.type];
      var target = e.target;
      if (triggers) {
        for (var i in triggers) {
          var trigger = triggers[i];
          if (trigger.selector == target || trigger.selector == document) {
            trigger.callback(e);
          } else if (target.matches && target.matches(trigger.selector)) {
            trigger.callback(e);
          }
        }
      }
    }
  }]);
}())();